import {
  appraiserContactCard,
  attorneyContactCard,
  contactCard,
  homeWarrantyContactCard,
  leadSourceCard,
  lenderContactCard,
  listingPriceCard,
  notesCard,
  otherContactCard,
  propertyBeingSoldCard,
  salesPriceCard,
  titleOfficerContactCard,
} from '../shared';
import type { DefaultCoverSheetConfig, LocaleOverrides } from '../types';
import {
  buyerCard,
  commissionDetailsCard,
  importantDatesCard,
  mlsInformationCard,
  propertyDetailsCard,
  sellerCard,
} from './cards';

export const BaseListingConfig = {
  version: '1',
  sections: {
    propertyInfo: {
      id: 'propertyInfo',
      header: 'Property Info',
      sidebarText: 'Property Info',
      cards: {
        propertyBeingSoldCard,
        propertyDetailsCard,
        importantDatesCard,
        mlsInformationCard,
        listingPriceCard,
        commissionDetailsCard,
        salesPriceCard,
        notesCard,
      },
    },
    sellerSideContacts: {
      id: 'sellerSideContacts',
      header: "Seller's Contacts",
      sidebarText: 'Seller Contacts',
      cards: {
        sellersAgentCard: contactCard(
          'sellerSideContacts.sellersAgent',
          'agent',
        ),
        sellerCard,
        leadSourceCard,
      },
    },
    buyerSideContacts: {
      id: 'buySideContacts',
      header: "Buyer's Contacts",
      sidebarText: 'Buyer Contacts',
      cards: {
        buyersAgentCard: contactCard(
          'buySideContacts.buyersAgent',
          'counterpartyAgent',
        ),
        buyerTCCard: contactCard(
          'buySideContacts.buyersTC',
          'counterpartyTransactionCoordinator',
        ),
        buyerCard,
      },
    },
    additionalContacts: {
      id: 'additionalContacts',
      header: 'Additional Contacts',
      sidebarText: 'Additional Contacts',
      cards: {
        titleOfficerContactCard,
        lenderContactCard,
        appraiserContactCard,
        attorneyContactCard,
        homeWarrantyContactCard,
        otherContactCard,
      },
    },
  },
} satisfies DefaultCoverSheetConfig;

export type ListingLocaleOverrides = LocaleOverrides<typeof BaseListingConfig>;
